import request from '@/services/interceptor.js'


export const get_modelli = (par) => {
  return request({
    url: '/api/preventivi/modello/' + par,
    method: 'get'
  })
};

export const get_varianti = (tipo, posizione, id) => {
  return request({
    url: '/api/preventivi/varianti/' + tipo + '/' + posizione + '/' + id,
    method: 'get'
  })
};

export const get_datiTestata = (numprev, idUtente) => {
  return request({
    url: '/api/preventivi/numero/' + numprev + '/' + idUtente,
    method: 'get'
  })
};


export const get_progDettaglio = (par) => {
  return request({
    url: '/api/preventivi/dettaglio/' + par,
    method: 'get'
  })
};

export const get_listaPreventivi = (gg, idUtente) => {
  return request({
    url: '/api/preventivi/lista/' + gg + '/' + idUtente,
    method: 'get'
  })
};

//ritorna la lista delle varianti per la visualizzazione in modifica
export const get_dettaglioPrev = (numPrev, pos) => {
  return request({
    url: '/api/preventivi/lista/dettaglio/' + numPrev + '/' + pos,
    method: 'get'
  })
};

export const get_tabellaDettaglio = (numPrev) => {
  return request({
    url: '/api/preventivi/dettaglio/tabella/' + numPrev,
    method: 'get'
  })
}

export const get_Misure = (tipo, numPrev, prog) => {
  return request({
    url: '/api/preventivi/dettaglio/misure/' + tipo + '/' + numPrev + '/' + prog,
    method: 'get'
  })
}

export const get_disegnoDettaglio = (tipoDoc, par) => {
  return request({
    url: '/api/preventivi/file/' + tipoDoc + '/dettaglio',
    method: 'post',
    data: par
  })
}

export const dup_RigoDettaglio = (dati, numPrev, prog) => {
  return request({
    url: '/api/preventivi/duplica/' + numPrev + '/' + prog,
    method: 'post',
    data: dati
  })
}

export const stampa_Preventivo = (prog) => {
  return request({
    url: '/api/preventivi/stampa/' + prog,
    method: 'get',
    responseType: 'blob',
  })
}


/** SET */
export const set_testata = (datiTestata) => {
  return request({
    url: '/api/preventivi/testata',
    method: 'post',
    data: datiTestata
  })
};

export const set_posizione = (datiPos) => {
  return request({
    url: '/api/preventivi/posizione',
    method: 'post',
    data: datiPos
  })
};

export const set_variante = (par) => {
  return request({
    url: '/api/preventivi/variante',
    method: 'post',
    data: par
  })
}


export const set_maggiorazioni = (par) => {
  return request({
    url: '/api/preventivi/maggiorazioni/set',
    method: 'post',
    data: par
  })
}

export const get_maggiorazioni = (par) => {
  return request({
    url: '/api/preventivi/maggiorazioni',
    method: 'post',
    data: par
  })
}

/** DEL */
export const del_preventivo = (numPrev) => {
  return request({
    url: '/api/preventivi/ordine/' + numPrev,
    method: 'delete',
  })
}

export const del_dettaglioPreventivo = (numPrev, posDett) => {
  return request({
    url: '/api/preventivi/ordine/' + numPrev + '/' + posDett,
    method: 'delete',
  })
}

export const upload_filePreventivi = (par) => {
  return request({
    url: '/api/preventivi/testata/upload',
    method: 'post',
    data: par,
    noLoadingBar: true
  })
};

export const get_filePreventivi = () => {
  return request({
    url: '/api/preventivi/testata/immagine',
    method: 'get',
  })
};